import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyBuyBar() {
  const [scrolled, setScrolled] = useState(false);
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/sistema-completo-de-ventas-en-amazon-fba-fbm-2026', '_blank', 'noopener,noreferrer');
  };
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const visible = scrolled;
  return <AnimatePresence data-id="element-903">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.28,
      ease: 'easeOut'
    }} className="md:hidden fixed bottom-0 inset-x-0 z-50 px-3 pb-[calc(env(safe-area-inset-bottom,0px)+0.6rem)] pt-2" data-id="element-904">
          <div className="flex items-center gap-3 rounded-2xl border border-brand-gold/30 bg-white px-4 py-3 shadow-[0_-6px_24px_-8px_rgba(0,0,0,0.18)]" data-id="element-905">
            <div className="min-w-0 flex-1" data-id="element-906">
              <p className="truncate text-[13px] font-bold leading-tight text-brand-green" data-id="element-907">
                Amazon Master System™
              </p>
              <p className="mt-1 text-[11px] font-semibold leading-tight text-brand-text/65" data-id="element-908">
                Acceso inmediato • Solo $27.99 USD
              </p>
            </div>
            <button type="button" onClick={goToCheckout} aria-label="Comenzar ahora" className="shrink-0 rounded-xl bg-brand-green px-4 py-3 text-xs font-bold tracking-wide text-white shadow-lg shadow-brand-green/25 transition-colors duration-200 hover:bg-brand-green/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold focus-visible:ring-offset-2" data-id="element-909">
              🟢 COMENZAR AHORA
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}